import { ReactNode, useState } from 'react'
import makeStyles from '@mui/styles/makeStyles'
import Modal from '@mui/material/Modal'

function rand() {
  return Math.round(Math.random() * 20) - 10
}

function getModalStyle() {
  const top = 50 + rand()
  const left = 50 + rand()

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`
  }
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    width: 'auto',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3)
  }
}))

interface SimpleModalProps {
  body: ReactNode
  isOpen?: boolean
  setModal?: (modal: boolean) => void
}

export const SimpleModal = ({
  body,
  isOpen = false,
  setModal
}: SimpleModalProps) => {
  const classes = useStyles()
  const [modalStyle] = useState(getModalStyle)

  const handleClose = () => {
    if (setModal) {
      setModal(false)
    }
  }

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
    >
      <div style={modalStyle} className={classes.paper}>
        {body}
      </div>
    </Modal>
  )
}
